import {
  Album,
  AnyAlbumEntityVersion,
  FirestoreEntity,
  Mapper,
  NotFoundError,
} from '@uploadcam/common';
import { CollectionReference, doc, getDoc } from 'firebase/firestore';

export class GetAlbumByIdInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyAlbumEntityVersion>,
    private readonly mapper: Mapper<unknown, Album>,
  ) {}

  public async execute(id: string): Promise<Album> {
    const albumRef = doc(this.collection, id);
    const albumDoc = await getDoc(albumRef);
    const albumData = albumDoc.data();

    if (!albumData) {
      throw new NotFoundError('Album not found');
    }

    return this.mapper.map(FirestoreEntity.from(albumDoc));
  }
}
